import { Drawer } from "antd";
import close from "./../../../../assets/images/close.svg";
import {
  deleteKeysFromLocalStorage,
  getLocalStorage,
} from "../../../../utils/localStorage";
import {
  JWT_TOKEN,
  LangSpecificMsg,
  LANGUAGE,
  MOBILE_NUMBER,
} from "../../../symptomCollector/utils/constants";
import { ValidLanguages } from "../../../symptomCollector/utils/types";

const Logout = ({ show, closePopup, handleClose }: any) => {
  const selectedLanguage = getLocalStorage(LANGUAGE);
  const LangSpecificMsgData =
    LangSpecificMsg[(selectedLanguage as ValidLanguages) || "english"];

  const onLogout = () => {
    const jwtToken = getLocalStorage(JWT_TOKEN);
    deleteKeysFromLocalStorage([MOBILE_NUMBER, LANGUAGE, JWT_TOKEN]);
    handleClose();
    closePopup();
    window.location.href = `/appointment-booking?jwtToken=${jwtToken}`;
  };
  return (
    <Drawer
      placement="bottom"
      onClose={closePopup}
      closeIcon={false}
      open={show}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">
            {LangSpecificMsgData.logoutConfirmation}
          </div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
      </div>
      <section className="flex justify-center gap-5 mt-6 w-full text-base font-medium tracking-normal leading-loose text-center">
        <button
          className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-indigo-600 bg-white whitespace-nowrap rounded-xl border border-indigo-600 border-solid flex justify-center`}
          aria-label={"cancel"}
          onClick={onLogout}
        >
          {LangSpecificMsgData.logout}
        </button>
        <button
          className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid flex justify-center`}
          aria-label={"logout"}
          onClick={closePopup}
        >
          {LangSpecificMsgData.stay}
        </button>
      </section>
    </Drawer>
  );
};

export default Logout;
